import Keys from 'preferences/preferences';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { symptomTrackingActions } from 'store/symptomTracking';
import { selectShouldAskForPeriod } from 'store/symptomTracking/selectors';
import usePreferences from './usePreferences';

const useShouldAskForPeriod = () => {
  const dispatch = useDispatch();
  // TODO use in preferences as well

  // Redux selector
  const shouldAskForPeriod = useSelector(selectShouldAskForPeriod);

  // Preference hook
  const {
    set: setShouldAskForPeriodPreference,
    clear: clearShouldAskForPeriodPreference,
    loading: loadingShouldAskForPeriod,
  } = usePreferences(Keys.TRACKING_SURVEY_SHOULD_ASK_FOR_PERIOD, value => {
    // Convert preference string values to boolean
    dispatch(symptomTrackingActions.setShouldAskForPeriod(value !== false));
  });

  // Actions that update both preferences and store
  const setShouldAskForPeriod = useCallback(
    (enabled: boolean) => {
      if (enabled) {
        setShouldAskForPeriodPreference('true');
      } else {
        setShouldAskForPeriodPreference('false');
      }
      // The Redux action will be triggered by the preference callback
    },
    [setShouldAskForPeriodPreference],
  );

  const clearShouldAskForPeriod = useCallback(() => {
    clearShouldAskForPeriodPreference();
    // When cleared, default to true (ask for period tracking)
    dispatch(symptomTrackingActions.setShouldAskForPeriod(true));
  }, [clearShouldAskForPeriodPreference, dispatch]);

  return {
    // State
    isPeriodTrackingEnabled: shouldAskForPeriod !== false,

    // Loading state
    loadingShouldAskForPeriod,

    // Actions
    setShouldAskForPeriod,
    clearShouldAskForPeriod,
  };
};

export default useShouldAskForPeriod;
